import { Const } from "./constants";

export interface CanvasModel {
  getWidth(): number;
  getHeight(): number;
  resizeCanvas(width: number, height: number, worldLoaded?: boolean): void;
  setKarelDimensions(rows: number, cols: number): void;
  getCornerSize(): number;
  getWorldLeft(): number;
  getWorldTop(): number;
  getWorldWidth(): number;
  getWorldHeight(): number;
}

export function CanvasModel(
  canvasWidth: number,
  canvasHeight: number,
): CanvasModel {
  let cornerSize = 0;
  let worldLeft = 0;
  let worldTop = 0;
  let worldWidth = 0;
  let worldHeight = 0;

  let worldRows = 0;
  let worldCols = 0;

  const that: CanvasModel = {
    getWidth: () => canvasWidth,
    getHeight: () => canvasHeight,

    resizeCanvas(width: number, height: number, worldLoaded?: boolean): void {
      canvasWidth = width;
      canvasHeight = height;
      if (worldLoaded) {
        that.setKarelDimensions(worldRows, worldCols);
      }
    },

    setKarelDimensions(rows: number, cols: number): void {
      worldRows = rows;
      worldCols = cols;
      // Fit the grid inside a box that is WORLD_FILL of the canvas on each
      // axis, so the longest side of the world takes ~80% of the area.
      const boxWidth = canvasWidth * Const.WORLD_FILL;
      const boxHeight = canvasHeight * Const.WORLD_FILL;
      cornerSize = Math.min(boxWidth / cols, boxHeight / rows);
      worldWidth = cols * cornerSize;
      worldHeight = rows * cornerSize;

      worldTop = (canvasHeight - worldHeight) / 2;
      worldLeft = (canvasWidth - worldWidth) / 2;
    },

    getCornerSize: () => cornerSize,
    getWorldLeft: () => worldLeft,
    getWorldTop: () => worldTop,
    getWorldWidth: () => worldWidth,
    getWorldHeight: () => worldHeight,
  };

  return that;
}
